import { PROFILE_STATUS } from "./constants";
import { GA4UserProperties } from "./analytics";

export function deriveUserProperties(
  profile: any,
): GA4UserProperties {
  return {
    user_type: deriveUserType(profile),
    city: profile?.city ?? null,
    membership_type: deriveMembershipType(profile),
    industry: profile?.industry ?? null,
  };
}

function deriveUserType(profile: any): "New" | "Returning" {
  return profile?.credit?.is_first_time_member === true ? "New" : "Returning";
}

function deriveMembershipType(
  profile: any,
): "Free" | "Paid" | "Corporate" | null {
  const status = profile?.credit?.status;
  const membershipType = profile?.credit?.membership_type;

  if (
    status === PROFILE_STATUS.NON_MEMBER ||
    status === PROFILE_STATUS.UNDER_REVIEW ||
    status === PROFILE_STATUS.PAYMENT_PENDING
  ) {
    return "Free";
  }

  if (status === PROFILE_STATUS.MEMBER) {
    if (membershipType === "CORPORATE") return "Corporate";
    return "Paid";
  }

  return null;
}
